var map = {
	"./AMPAY.png": 608,
	"./ANYPAY.png": 609,
	"./BAAC.png": 610,
	"./BAY.png": 611,
	"./BBL.png": 612,
	"./BITPAYz.png": 613,
	"./CIMB.png": 614,
	"./GHBANK.png": 615,
	"./GM2PAY.png": 616,
	"./GSB.png": 617,
	"./HYRONPAY.png": 618,
	"./IBANK.png": 619,
	"./KBANK.png": 620,
	"./KK.png": 621,
	"./KTB.png": 622,
	"./LHBANK.png": 623,
	"./MXSOUL.png": 624,
	"./NONE.png": 350,
	"./P2PAY.png": 625,
	"./SCB.png": 626,
	"./SECUREPAY.png": 627,
	"./THUNDERPAY.png": 628,
	"./TRUEWALLET.png": 629,
	"./TTB.png": 630,
	"./TWOSTEPX.png": 631,
	"./UOB.png": 632,
	"./logo-bank-0.png": 633,
	"./logo-bank-1.png": 634,
	"./logo-bank-10.png": 635,
	"./logo-bank-11.png": 636,
	"./logo-bank-12.png": 637,
	"./logo-bank-13.png": 638,
	"./logo-bank-14.png": 639,
	"./logo-bank-2.png": 640,
	"./logo-bank-3.png": 641,
	"./logo-bank-4.png": 642,
	"./logo-bank-5.png": 643,
	"./logo-bank-6.png": 644,
	"./logo-bank-7.png": 645,
	"./logo-bank-8.png": 646,
	"./logo-bank-9.png": 647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 607;